export default "__VITE_ASSET__DrbfNhCx__"